import { AlertTriangle } from 'lucide-react'
import { useColors } from '../../hooks/useColors'

interface ErrorStateProps {
  message?: string
  onRetry?: () => void
}

export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  const colors = useColors()

  return (
    <div
      style={{
        padding: '48px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <AlertTriangle size={40} color="var(--color-error)" />
      <p
        className="font-display"
        style={{
          margin: 0,
          fontSize: '16px',
          fontWeight: 600,
          color: colors.textPrimary,
        }}
      >
        Something went wrong
      </p>
      <p
        className="font-body"
        style={{
          margin: 0,
          fontSize: '13px',
          color: colors.textSecondary,
        }}
      >
        {message || 'Unable to load data. Please try again.'}
      </p>
      {onRetry && (
        <button
          type="button"
          className="font-body"
          onClick={onRetry}
          style={{
            marginTop: '8px',
            height: '36px',
            padding: '0 16px',
            borderRadius: '999px',
            border: `1px solid ${colors.border}`,
            background: 'transparent',
            color: colors.textPrimary,
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Try Again
        </button>
      )}
    </div>
  )
}
